module.exports = __webpack_public_path__ + "static/media/steam.2a3ee376.svg";